<div class="menu-container">
  <ion-list lines="none">
    @if (_configuration()) {
      <div
        class="menu-group"
        *hasClaim="[
          'CanAccessConfigurationsManaged',
          'CanAccessConfigurationsAll',
        ]"
      >
        @if (canInstall()) {
          <ion-item button (click)="clickMenu('install')">
            <ion-icon
              slot="start"
              name="arrow-down-circle-outline"
              color="primary"
            ></ion-icon>
            <ion-label>{{ 'configuration_install' | translate }}</ion-label>
          </ion-item>
        }
      </div>
    }

    @if (_menus().length > 0) {
      <div class="menu-group separator">
        @for (menu of _menus(); track menu.action) {
          <ion-item button (click)="clickMenu(menu.action)">
            <ion-icon
              slot="start"
              [name]="menu.icon || 'ellipsis-horizontal'"
            ></ion-icon>
            <ion-label>{{ menu.name | translate }}</ion-label>
          </ion-item>
        }
      </div>
    }
  </ion-list>
</div>
